import { combineReducers } from "redux";
import projectReducer from './projectReducer';
import equipmentReducer from './equipmentReducer';
import userReducer from './userReducer';
import surveyReducer from './surveyReducer';
import taskReducer from './taskReducer';
import loginReducer from './loginReducer';
import selectProjectReducer from './selectProjectReducer'
import projectRoleReducer from "./projectRoleReducer";
import materialReducer from "./materialReducer";
import locationReducer from "./locationReducer";
import serviceFirmReducer from "./serviceFirmReducer";
import checklistReducer from "./checklistReducer";
import supportReducer from "./supportReducer";
import poolReducer from "./poolReducer";
import qrcodeReducer from "./qrcodeReducer";
import equipmentTreesReducer from "./equipmentTreesReducer";
import jobReducer from "./jobReducer";
import photosReducer from "./photosReducer";
import notificationReducer from "./notificationReducer";
import documentReducer from "./documentReducer";
import dashboardReducer from "./dashboardReducer";
import pageReducer from "./pageReducer";
import rolesReducer from "./rolesReducer";
import rolePagesReducer from "./rolePagesReducer";
import warehouseReducer from "./warehouseReducer";
import tenantReducer from "./tenantReducer";
import customerReducer from "./customerReducer";
import contactReducer from "./contactReducer";
import firmaReducer from "./firmaReducer";
import contractReducer from "./contractReducer";
import crmInvoiceReducer from "./crmInvoiceReducer";
import leadsReducer from "./leadsReducer";
import createTypeReducer from "./createTypeReducer";
import budgetReducer from "./budgetReducer";
import talepReducer from "./talepReducer";
import inventoryReducer from "./inventoryReducer";

export default combineReducers({
    projectReducer: projectReducer,
    equipmentReducer: equipmentReducer,
    userReducer: userReducer,
    surveyReducer: surveyReducer,
    taskReducer: taskReducer,
    loginReducer: loginReducer,
    selectProjectReducer: selectProjectReducer,
    projectRoleReducer: projectRoleReducer,
    materialReducer: materialReducer,
    locationReducer: locationReducer,
    serviceFirmReducer: serviceFirmReducer,
    checklistReducer: checklistReducer,
    supportReducer: supportReducer,
    poolReducer: poolReducer,
    qrcodeReducer: qrcodeReducer,
    equipmentTreesReducer: equipmentTreesReducer,
    jobReducer: jobReducer,
    notificationReducer: notificationReducer,
    photosReducer: photosReducer,
    documentReducer: documentReducer,
    dashboard: dashboardReducer,
    pages: pageReducer,
    roles: rolesReducer,
    rolePages: rolePagesReducer,
    warehouses: warehouseReducer,
    tenantReducer: tenantReducer,
    customers: customerReducer,
    contactReducer: contactReducer,
    firmalar: firmaReducer,
    crmInvoiceReducer: crmInvoiceReducer,
    leadsReducer: leadsReducer,
    createTypeReducer: createTypeReducer,
    contractReducer: contractReducer,
    budgetReducer: budgetReducer,
    talepler: talepReducer,
    inventoryReducer: inventoryReducer,
});
